import React from "react";
import { Badge, Button, Form } from "react-bootstrap";
import { StarRating } from "./StarRating";

/**
 * One student in the class session: a present/absent toggle that, when on,
 * reveals the star rating + hours. Attendance and grading live in one row.
 * Provisional (alta rápida) students show a badge + a "Vincular" action.
 */
function StudentScoreRow({
  entry,
  present,
  score,
  hours,
  busy,
  onTogglePresent,
  onScoreChange,
  onLink,
  levels = [],
  onLevelChange,
  levelBusy,
  defaultHours,
}) {
  const student = entry.student ?? entry;
  const isProvisional = entry.is_provisional === true;
  const currentLevelId = student.level?.id ?? "";
  const currentScore = score ?? 3;
  const currentHours = hours ?? defaultHours ?? 1;

  return (
    <div className="py-3 border-bottom" style={{ minHeight: 64 }}>
      <div className="d-flex align-items-center justify-content-between mb-1">
        <span className="fw-medium d-flex align-items-center gap-2 flex-wrap">
          {student.name}
          {isProvisional && (
            <Badge bg="warning" text="dark" pill>
              Provisional
            </Badge>
          )}
        </span>
        <Button
          variant={present ? "success" : "outline-secondary"}
          size="sm"
          onClick={() => onTogglePresent(!present)}
          disabled={busy}
          style={{ minHeight: 40, minWidth: 110 }}
        >
          {present ? "✓ Presente" : "Marcar"}
        </Button>
      </div>

      {isProvisional && onLink && (
        <div className="mb-1">
          <Button
            variant="link"
            size="sm"
            className="p-0 text-decoration-none"
            onClick={() => onLink(student)}
          >
            🔗 Vincular con estudiante registrado
          </Button>
        </div>
      )}

      {!isProvisional && onLevelChange && levels.length > 0 && (
        <div className="d-flex align-items-center gap-2 mb-1">
          <span className="text-muted small">Nivel:</span>
          <Form.Select
            size="sm"
            value={currentLevelId}
            onChange={(e) => onLevelChange(student.id, e.target.value || null)}
            disabled={levelBusy}
            style={{ maxWidth: 200 }}
            aria-label={`Nivel de ${student.name}`}
          >
            <option value="">Sin nivel</option>
            {levels.map((l) => (
              <option key={l.id} value={l.id}>
                {l.name}
              </option>
            ))}
          </Form.Select>
        </div>
      )}

      {present && (
        <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mt-2">
          <StarRating
            value={currentScore}
            onChange={onScoreChange}
            size={34}
            ariaLabel={`Calificación de ${student.name}`}
          />
          {/* Hours are set by the class duration — read-only here. */}
          <div className="d-flex align-items-center gap-1 text-muted small">
            <span aria-hidden="true">⏱</span>
            <span className="fw-semibold text-body">{currentHours}</span>
            <span>h</span>
          </div>
        </div>
      )}
    </div>
  );
}

export { StudentScoreRow };
